import { Location } from './../../_models/location';
import { Component, Input } from '@angular/core';
import { LatLngLiteral } from '@agm/core';
import { BAGCILAR_GEOPATHS } from '../../_models/bagcilar';

@Component({
  selector: 'multi-location',
  templateUrl: 'multi-location.html'
})
export class MultiLocationComponent {
  @Input('locations') locations: Location[];
  paths: Array<LatLngLiteral> = [];
  mapCenter: LatLngLiteral = {lng: 28.837840, lat: 41.041523 };
  public zoom: number = 13.5;
  @Input('currentLatitude') currentLatitude: number;
  @Input('currentLongitude') currentLongitude: number;

  constructor() {
    this.paths =  BAGCILAR_GEOPATHS;
    //console.log(this.paths);
  }
}



// WEBPACK FOOTER //
// ./src/components/multi-location/multi-location.ts